
const DEV_MODE = false;

export async function getAudioOutputDevices() {
   if (DEV_MODE) {
    return [
      { deviceId: "mock-device-1", label: "Mock Built-in Speaker" },
      { deviceId: "mock-device-2", label: "Mock Bluetooth Headset" },
    ];
  }
  // Request audio permission once
  await navigator.mediaDevices.getUserMedia({ audio: true });

  const devices = await navigator.mediaDevices.enumerateDevices();
  return devices.filter(d => d.kind === "audiooutput");
}
